// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPickDownloadHero-cls1_uNq","cls2":"LoswpPickDownloadHero-cls2_Fga LoswpPickDownloadHero-cls1_uNq"};